import { INavigationBehaviour, NavigationAwareObject } from "./NavigationAwareObject";
import { Scene } from "../Scene";
import { PathNode } from "@spi/Common/NavigationMesh";
import { RayTraceResult } from "@spi/Common/Math";
import { vec3, vec4 } from "gl-matrix";
import { VisualPathNodes } from "../Development/VisualPathNodes";
import { Subscription } from "rxjs";
import { LineList } from "../Development/LineList";

export class InputControlledBehaviour implements INavigationBehaviour {

    private pathSubscription: Subscription;

    constructor(public scene: Scene) {

    }

    attach(navObject: NavigationAwareObject) {

        let debugViewNodes = this.scene.debugManager.add('player-path-nodes', false);
        let debugViewLines = this.scene.debugManager.add('player-path-line', true);

        this.pathSubscription = navObject.pathChanged.subscribe(nodes => {
            if (nodes.length > 0) {
                let debugPathNodes = new VisualPathNodes(this.scene.ctx);
                debugPathNodes.setPathNodes(nodes.map(node => node.node), (s) => vec4.fromValues(Math.random(), Math.random(), Math.random(), 0.8));

                let pathLine = new LineList(this.scene.ctx);
                let points = [navObject.movement.positionObject.position, ...nodes.map(s => s.position)]
                    .map(p => vec3.fromValues(p[0], p[1], p[2] + 1));

                pathLine.setLines(points);
                debugViewNodes.objects = [debugPathNodes]
                debugViewLines.objects = [pathLine];
            }
        });

        let clickCallback = (treeType: string, eventType: string, hits: RayTraceResult[]) => {

            if (eventType !== 'mouseDown') {
                return false;
            }



            let target: PathNode = null;
            let intersection: vec3 = null;

            for (let hit of hits) {
                target = hit.object as PathNode;
                intersection = target.getRayIntersection(hit.ray, false);

                if (intersection) {
                    break;
                }
            }

            if (!intersection) {
                console.info('Click not trapped by surface, checking bounding box borders instead.');
                for (let hit of hits) {
                    target = hit.object as PathNode;
                    intersection = target.getRayIntersection(hit.ray, true);

                    if (intersection) {
                        break;
                    }
                }
            }

            if (!intersection) {
                console.warn('Clicked but no intersection within the bounding box was found?');
                return true;
            }

            navObject.navigateToNode(target, intersection);
            return true;
        };

        this.scene.pickingManager.registerSpatialDatabase(this.scene.navigationDatabase, 'nav-mesh', clickCallback, 100);
    }

    detach(navObject: NavigationAwareObject) {
        this.pathSubscription.unsubscribe();
        this.scene.debugManager.disable('player-path');
        this.scene.pickingManager.unregisterSpatialDatabase(this.scene.navigationDatabase);
    }
}